import React from 'react';

import { EmptyState } from '@ergeon/core-components';
import { DocumentTextIcon } from '@ergeon/icons/hero/outline';

export const NoExecutiveSummaryEmptyState = () => (
  <div className="flex flex-col flex-grow justify-center items-center p-6 w-full">
    <EmptyState
      description="Executive summary will be generated based on customer interactions."
      icon={<DocumentTextIcon />}
      title="No summary available" />
  </div>
);
